<script setup lang="ts">
import { formatDate } from "~/utils/dateUtils";
import { computed, inject } from "vue";

import { FormElementType, LinkedAnswerFormElement } from "~/api";
import { DefaultFormComponentProps } from "./FormComponentRenderer.vue";
import {
  formResponseInjectKey,
  FormResponseState,
} from "~/NewFormBuilder/composables/useFormResponse";
const props = defineProps<DefaultFormComponentProps<LinkedAnswerFormElement>>();

const { useAnswer, formResponse } = inject(
  formResponseInjectKey,
  // Cast the type since we know it is always provided. For more info see:
  // https://vuejs.org/guide/typescript/composition-api.html#typing-provide-inject
) as FormResponseState;
const answer = useAnswer<FormElementType.LINKED_ANSWER>(props.modelValue);

const linkedAnswerParsed = computed<string>(() => {
  if (!answer.value) {
    return "";
  }
  return JSON.parse(answer.value.linkedAnswer.answerValue);
});
</script>

<template id="form-linked-answer-component">
  <div class="linkedAnswerComponent">
    <slot name="label" :element="modelValue" />

    <div style="flex-grow: 1"></div>

    <div v-if="formResponse" v-loading="false" class="linkedAnswerValue">
      <template v-if="answer?.linkedAnswer">
        <span class="linkedAnswerUpdatedAt">
          (Last Modified: {{ formatDate(answer?.linkedAnswer.updatedAt, 5) }})
        </span>
        <span>
          {{ linkedAnswerParsed }}
        </span>
      </template>
      <div v-else class="linkedAnswerNoValue">No Answer</div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.linkedAnswerComponent {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;

  .linkedAnswerValue {
    display: flex;
    flex-direction: column;
    .linkedAnswerUpdatedAt {
      color: var(--el-color-info);
      font-size: 0.75em;
    }
  }

  .linkedAnswerNoValue {
    color: var(--el-color-danger);
  }
}
</style>
